<template>
  <div>
    <el-button type="primary" @click="downloadAplipayPdf">打印退款申请单</el-button>
  </div>
</template>

<script>
const Base64 = require('js-base64').Base64
import { html2pdf } from '../../request/apis';
import {AplipayHtml} from '../../utils/alipaypdf'


export default {
  name: 'TicAlipayPdf',
  props:{
    DataValue:{
      type:Object,
      default:()=>{}
    },
  },
  data() {
    return {
      apiHost: 'https://gateuat.sgsonline.com.cn',
    }
  },
  methods: {
    downloadAplipayPdf(){
      html2pdf({
        fileContent: Base64.encode(AplipayHtml(this.DataValue)),
      }, `${this.DataValue.orderNumber}退款申请.pdf`, this.apiHost, this, 'btnLoading')
    },
  }
};
</script>

<style scoped>

</style>
